/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Set_MasterInputs */

const en_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set as master resume`)
};

const de_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Master-Lebenslauf festlegen`)
};

const fr_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir comme CV principal`)
};

const es_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer como currículum principal`)
};

const it_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta come curriculum principale`)
};

const nl_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instellen als master-CV`)
};

const pl_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustaw jako główne CV`)
};

const fi_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aseta pääansioluetteloksi`)
};

const da_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sæt som master-CV`)
};

const sv_resumes_set_master = /** @type {(inputs: Resumes_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ställ in som huvud-CV`)
};

/**
* | output |
* | --- |
* | "Set as master resume" |
*
* @param {Resumes_Set_MasterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_set_master = /** @type {((inputs?: Resumes_Set_MasterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Set_MasterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_set_master(inputs)
	if (locale === "fr") return fr_resumes_set_master(inputs)
	if (locale === "es") return es_resumes_set_master(inputs)
	if (locale === "it") return it_resumes_set_master(inputs)
	if (locale === "nl") return nl_resumes_set_master(inputs)
	if (locale === "pl") return pl_resumes_set_master(inputs)
	if (locale === "fi") return fi_resumes_set_master(inputs)
	if (locale === "da") return da_resumes_set_master(inputs)
	if (locale === "sv") return sv_resumes_set_master(inputs)
	return en_resumes_set_master(inputs)
});